/* src/app/contract/contract-details-list/contract-details-list.component.css */
:host ::ng-deep .p-dropdown {
  width: 100% !important;
  max-width: 100% !important;
}
:host ::ng-deep .p-dropdown-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*# sourceMappingURL=contract-details-list.component-O7NZLTCM.css.map */
